import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AiOutput, AiReportResponse } from 'src/app/shared/models/aiReport.model';
import { jsonToHTML } from 'src/app/utils/json-to-html';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.scss']
})
export class ReportViewComponent implements OnChanges{

  @Input() input:AiReportResponse | undefined;

  formattedData: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['input']?.currentValue){
      this.formatInput(this.input!.output!);
    }
  }

  formatInput(input:AiOutput){
    if(input.type === 'json'){
      this.formattedData = jsonToHTML(input.json!);
      return;
    }
    if(input.type === 'html'){
      this.formattedData = input.html ?? '';
      return;
    }
    if(input.type === 'text'){
      this.formattedData = input.text ?? '';
      return;
    }
  }

}
